module.exports = {
    "small-min-width": "0px",
    "small-max-width": "767px",
    "medium-min-width": "768px",
    "medium-max-width": "992px",
    "large-min-width": "993px",
    "large-max-width": "1402px"
}